import { render, staticRenderFns } from "./ResizableAside.vue?vue&type=template&id=62935d8f&scoped=true"
import script from "./ResizableAside.vue?vue&type=script&lang=js"
export * from "./ResizableAside.vue?vue&type=script&lang=js"
import style0 from "./ResizableAside.vue?vue&type=style&index=0&id=62935d8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62935d8f",
  null
  
)

export default component.exports